import { EnvironmentProviders, inject, isDevMode, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

import { TranslationService, TranslocoHttpLoader } from '../data-access';
import { AVAILABLE_LANGUAGES, FALLBACK_LANGUAGE, Language } from '../utils';

const translationAppInitializer = (): Promise<any> => {
  const translationService = inject(TranslationService);
  return firstValueFrom(translationService.load(translationService.getActiveLang()));
};

export const translocoProvider = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: Language.EN,
        fallbackLang: FALLBACK_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          logMissingKey: false,
        },
      },
      loader: TranslocoHttpLoader,
    }),

    provideAppInitializer(() => translationAppInitializer()),
  ]);
